import {
  HStack,
  Radio,
  RadioGroup,
  Box,
  Flex,
} from '@chakra-ui/react';
import { useRecoilValue, useRecoilState } from 'recoil';
import { selectedDatabaseIdState } from '@transport-insights/uikit';
import { selectedRegionRoadTypeState, selectedTemporaryRegionRoadTypeState } from '../state';
import { roadTypeOptions } from '../shared/constants';

function RegionRoadTypeSelector({ ...rest }) {
  const rcaId = useRecoilValue(selectedDatabaseIdState);
  const tempRegionRoadType = useRecoilValue(selectedTemporaryRegionRoadTypeState);
  const [selectedRegionRoadType, setSelectedRegionRoadTypeState] = useRecoilState(selectedRegionRoadTypeState);

  const handleSelect = (value) => {
    setSelectedRegionRoadTypeState(value);
  };

  if (rcaId < 1000) return null;

  return (
    <Box
      width="fit-content"
      backgroundColor="gray.100"
      p={1}
      borderRadius="base"
      {...rest}
    >
      <RadioGroup onChange={handleSelect} value={tempRegionRoadType || selectedRegionRoadType}>
        <HStack spacing={1}>
          {roadTypeOptions.map((option) => (
            <Flex
              key={option.value}
              background={
              // eslint-disable-next-line no-nested-ternary
              option.value === tempRegionRoadType
                ? 'whiteAlpha.900'
                : tempRegionRoadType === null && option.value === selectedRegionRoadType
                  ? 'whiteAlpha.700'
                  : 'transparent'
            }
              borderRadius="sm"
              _hover={{
                background:
                option.value === tempRegionRoadType || option.value === selectedRegionRoadType
                  ? 'white'
                  : 'whiteAlpha.600',
              }}
            >
              <Radio
                value={option.value}
                size="sm"
                py={1}
                px={2}
                isDisabled={tempRegionRoadType !== null && tempRegionRoadType !== option.value}
                _disabled={{
                  borderColor: 'gray.200',
                }}
              >
                {option.label}
              </Radio>
            </Flex>
          ))}
        </HStack>
      </RadioGroup>
    </Box>
  );
}

export default RegionRoadTypeSelector;
